import shortTimeCreatedSuccessfully from './short-time-created-successfully.json';
import insufficientBalance from './insufficient-balance.json';

export default {
  bucket: {
    ...shortTimeCreatedSuccessfully,
    ...insufficientBalance,
  },
};
